/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingAccessMode = {
    Open: 'Open',
    Closed: 'Closed'
} as const;
export type ParkingAccessMode = typeof ParkingAccessMode[keyof typeof ParkingAccessMode];

